import { FieldInstruction } from 'containers/FormBuilder'
import AutomobileVehicleSelectionBaseField from 'form/fieldComponents/AutomobileVehicleSelectionBaseField'
import {
    FIELD_GREATER_THAN_ZERO,
    FIELD_REQUIRED,
    FIELD_TOO_LONG,
    VIN_LENGTH,
} from 'form/validation/validationMessages'
import AssetType from 'state/enums/AssetType'
import { BookingSource } from 'utils/bookingSourceHelper'
import * as Yup from 'yup'

const automobileVehicleSelectionSchema = Yup.object().shape({
    condition: Yup.string().required(),
    year: Yup.number().required(FIELD_REQUIRED).moreThan(0, FIELD_REQUIRED),
    make: Yup.string().required(FIELD_REQUIRED),
    model: Yup.string()
        .max(200, FIELD_TOO_LONG(200))
        .matches(
            /^[A-Za-z0-9 \-.()/&,'"*+!:#]*$/,
            'Only the following special characters are allowed: - . ( ) / & , \' " * + ! : #',
        )
        .required(FIELD_REQUIRED),
    trim: Yup.string()
        .max(200, FIELD_TOO_LONG(200))
        .matches(
            /^[A-Za-z0-9 \-.()/&,'"*+!:#]*$/,
            'Only the following special characters are allowed: - . ( ) / & , \' " * + ! : #',
        )
        .required(FIELD_REQUIRED),
    invoice: Yup.number().when('condition', {
        is: 'new',
        then: Yup.number()
            .required(FIELD_REQUIRED)
            .moreThan(0, FIELD_GREATER_THAN_ZERO),
    }),
    bookingSource: Yup.string().when('condition', {
        is: 'used',
        then: Yup.string().required(FIELD_REQUIRED),
    }),
    mileage: Yup.number().when('condition', {
        is: 'used',
        then: Yup.number()
            .required(FIELD_REQUIRED)
            .integer()
            .moreThan(0, FIELD_GREATER_THAN_ZERO),
    }),
    wholesale: Yup.number().when(['condition', 'bookingSource'], {
        is: (condition: string, bookingSource: string) =>
            condition === 'used' &&
            bookingSource !== BookingSource.LIKE_INVOICE,
        then: Yup.number()
            .required(FIELD_REQUIRED)
            .moreThan(0, FIELD_GREATER_THAN_ZERO),
    }),
    likeInvoice: Yup.number().when(['condition', 'bookingSource'], {
        is: (condition: string, bookingSource: string) =>
            condition === 'used' &&
            bookingSource === BookingSource.LIKE_INVOICE,
        then: Yup.number()
            .required(FIELD_REQUIRED)
            .moreThan(0, FIELD_GREATER_THAN_ZERO),
    }),
    isCpo: Yup.boolean(),
    vin: Yup.string()
        .length(17, VIN_LENGTH)
        .matches(/^[A-Za-z0-9]*$/, 'VIN must be alphanumeric'),
})

export const vehicleSelectionAutomobileFields: FieldInstruction<
    typeof AutomobileVehicleSelectionBaseField
> = {
    Component: AutomobileVehicleSelectionBaseField,
    config: {
        initialValue: {
            condition: 'new',
            year: '',
            makeId: '',
            make: '',
            model: '',
            modelId: '',
            trim: '',
            automobileId: '',
            vin: '',
            nadaAccessories: [],
            invoice: '',
            bookingSource: '',
            mileage: '',
            wholesale: '',
            isCpo: false,
        },
        assetType: AssetType.AUTOMOBILE,
        validator: automobileVehicleSelectionSchema,
    },
}
